import { AuthService } from './../auth/service/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpClientInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    public authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(0),
      catchError((error: HttpErrorResponse) => {
        console.log('HTTP Error:', error.status, error.url);

        // ONLY clear storage and logout on 401 Unauthorized
        if (error && error.status == 401) {
          console.log('401 Unauthorized - Logging out');
          window.localStorage.clear();
          this.authService.toast.snackbarError("Session expired. Please login again.");
          this.router.navigate(['/login']);
        }
        // For 500 errors - DO NOT clear storage or logout
        else if (error && error.status == 500) {
          console.log('500 Server Error - Keeping user logged in');
          // Just show error message, don't logout
          this.authService.toast.snackbarError("Server error. Please try again later.");
          // DO NOT clear localStorage
          // DO NOT navigate to login
        }
        // For other errors (404, 403, etc.) - Just show message
        else if (error && error.status == 404) {
          console.log('404 Not Found');
          this.authService.toast.snackbarError("Resource not found.");
        }
        else if (error && error.status == 403) {
          console.log('403 Forbidden');
          this.authService.toast.snackbarError("You don't have permission to access this resource.");
        }
        else if (error && error.status == 0) {
          console.log('Network Error');
          this.authService.toast.snackbarError("Network error. Please check your connection.");
        }
        else {
          console.log('Other Error:', error.status);
          this.authService.toast.snackbarError(error.message || "An error occurred");
        }

        // Re-throw the error after handling
        return throwError(() => error);
      })
    );
  }
}